"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlugin = exports.Plugin = void 0;
var Plugin_1 = require("./plugin/models/Plugin");
Object.defineProperty(exports, "Plugin", { enumerable: true, get: function () { return Plugin_1.Plugin; } });
var Plugin_2 = require("./plugin/models/Plugin");
Object.defineProperty(exports, "isPlugin", { enumerable: true, get: function () { return Plugin_2.isPlugin; } });
//# sourceMappingURL=index.js.map